import { GetterTree } from 'vuex';

import { RootStateI } from './state';

const getters: GetterTree<RootStateI, RootStateI> = {
  getShowSidebar(state) {
    return state.showSidebar;
  },
  getBusiness(state) {
    const business = localStorage.getItem('business');
    if (business) return JSON.parse(business);
    return state.business;
  },
};

export default getters;
